// Un seul chemin vers l'API : les erreurs reviennent toujours sous la même
// forme, avec le message écrit par l'API plutôt qu'un code technique.

export class ErreurApi extends Error {
  statut: number
  constructor(message: string, statut: number) {
    super(message)
    this.statut = statut
  }
}

type Options = {
  methode?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'
  corps?: unknown
  formulaire?: FormData
}

export async function api<T>(chemin: string, options: Options = {}): Promise<T> {
  const reponse = await fetch(chemin, {
    method: options.methode ?? 'GET',
    credentials: 'include',
    headers: options.corps ? { 'Content-Type': 'application/json' } : undefined,
    body: options.formulaire ?? (options.corps ? JSON.stringify(options.corps) : undefined),
  })

  if (reponse.status === 204) return undefined as T

  const texte = await reponse.text()
  let charge: unknown = null
  try {
    charge = texte ? JSON.parse(texte) : null
  } catch {
    charge = { erreur: texte }
  }

  if (!reponse.ok) {
    const message =
      (charge as { erreur?: string } | null)?.erreur ??
      `L'application n'a pas pu répondre (code ${reponse.status}).`
    throw new ErreurApi(message, reponse.status)
  }

  return charge as T
}

export function messageErreur(erreur: unknown): string {
  if (erreur instanceof ErreurApi) return erreur.message
  if (erreur instanceof Error) return erreur.message
  return "Une erreur inattendue s'est produite."
}
